/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusAdminDeductReqVo
 */
export interface BonusAdminDeductReqVo {
    /**
     * 用户ID
     * @type {number}
     * @memberof BonusAdminDeductReqVo
     */
    userId: number;
    /**
     * 扣减金额（>0，不允许扣成负数）
     * @type {number}
     * @memberof BonusAdminDeductReqVo
     */
    amount: number;
    /**
     * 扣减内容（必填，原文记入流水备注）
     * @type {string}
     * @memberof BonusAdminDeductReqVo
     */
    remark: string;
}

/**
 * Check if a given object implements the BonusAdminDeductReqVo interface.
 */
export function instanceOfBonusAdminDeductReqVo(value: object): value is BonusAdminDeductReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('remark' in value) || value['remark'] === undefined) return false;
    return true;
}

export function BonusAdminDeductReqVoFromJSON(json: any): BonusAdminDeductReqVo {
    return BonusAdminDeductReqVoFromJSONTyped(json, false);
}

export function BonusAdminDeductReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusAdminDeductReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'amount': json['amount'],
        'remark': json['remark'],
    };
}

export function BonusAdminDeductReqVoToJSON(json: any): BonusAdminDeductReqVo {
    return BonusAdminDeductReqVoToJSONTyped(json, false);
}

export function BonusAdminDeductReqVoToJSONTyped(value?: BonusAdminDeductReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'amount': value['amount'],
        'remark': value['remark'],
    };
}

